import { createSelector } from '@reduxjs/toolkit';

const getState = (state) => state.command;

export const commandsListSelector = createSelector(getState, (state) => state.commands);
export const commandsMetaDataSelector = createSelector(getState, (state) => state.metaData);

export const isLoadingCreateCommandSelector = createSelector(
  getState,
  (state) => state.isLoadingCreateCommand
);
export const isLoadingFetchCommandsSelector = createSelector(
  getState,
  (state) => state.isLoadingFetchCommands
);
export const isLoadingUpdateCommandSelector = createSelector(
  getState,
  (state) => state.isLoadingUpdateCommand
);
export const isLoadingDeleteCommandSelector = createSelector(
  getState,
  (state) => state.isLoadingDeleteCommand
);
